import { render, staticRenderFns } from "./SignUpPageRepresentatives.vue?vue&type=template&id=451a8162&"
import script from "./SignUpPageRepresentatives.vue?vue&type=script&lang=js&"
export * from "./SignUpPageRepresentatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports